import { User } from "../models/User";

/**
 * Which identifiers still need a code, counting only the ones the account has.
 *
 * Phone-first sign-in produces accounts with a verified number and no email at
 * all, and the backend pins `email_verified` to false whenever `email` is null.
 * Guards that read `!verifiedEmail` on its own therefore trap those users on
 * /verify forever: there is no address to send a code to, so the flag they are
 * being held for can never flip.
 */
export const needsPhoneVerification = (user?: User | null): boolean =>
  !!user?.mobile?.code && !!user?.mobile?.phone && !user.verifiedMobile;

export const needsEmailVerification = (user?: User | null): boolean =>
  !!user?.email && !user.verifiedEmail;

export const needsVerification = (user?: User | null): boolean =>
  needsPhoneVerification(user) || needsEmailVerification(user);
